import GnForm from "../../../components/GnForm/index.js";
import GnTable from "../../../components/GnTable/index.js";
import {useUpdateRoute} from "../../../lib/useIframe.js";
import {useLayoutState} from "../../../store/layout.js";
import {request} from "../../../utils/request/index.js";
import {EditOutlined, InfoCircleFilled} from "../../../../__snowpack__/pkg/@ant-design/icons.js";
import {useRequest, useUpdateEffect} from "../../../../__snowpack__/pkg/ahooks.js";
import {Alert, Button, InputNumber, message, Modal, Popconfirm, Space, Tooltip} from "../../../../__snowpack__/pkg/antd.js";
import React, {useRef, useState} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
const isEditableVariation = (variation) => {
  return variation.productV2Enabled && variation.stockManuallyEditable || !variation.productV2Enabled && !variation.hasInventorySku;
};
export default function EditStockModal(props) {
  const {product, onClose} = props;
  const {formatMessage} = useIntl();
  const [batchStockInputValue, setBatchStockInputValue] = useState();
  const [isUpdateFailed, setIsUpdateFailed] = useState(false);
  const [variations, setVariations] = useState([]);
  const [form] = GnForm.useForm();
  const ref = useRef({autoFocusVariation: void 0});
  const {withPermission} = useLayoutState();
  const {updateRoute} = useUpdateRoute();
  const {run: updateStocks, loading: updateStockLoading} = useRequest((variationStocks) => request.post("/saas/product/v1/sync-stock/manual", [
    {
      productId: product.id,
      variationStocks
    }
  ]), {
    manual: true,
    onBefore: () => {
      setIsUpdateFailed(false);
    },
    onSuccess: (data) => {
      if (data?.[0]) {
        setIsUpdateFailed(true);
        setVariations(data[0].details);
      } else {
        message.success(formatMessage({id: "updateSuccessFul"}));
        onClose(true);
      }
    }
  });
  useUpdateEffect(() => {
    if (product?.details) {
      setVariations(product?.details);
      product.details.filter((variation) => isEditableVariation(variation)).forEach((variation) => {
        if (variation.$shouldAutoFocus) {
          ref.current.autoFocusVariation = variation.id;
          delete variation.$shouldAutoFocus;
        }
      });
      form.resetFields();
    }
  }, [!!product]);
  return /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "adjustStock"}),
    visible: !!product,
    width: 800,
    centered: true,
    bodyStyle: {maxHeight: "70vh", overflow: "auto"},
    onCancel: () => {
      onClose(!isUpdateFailed);
    },
    onOk: () => {
      form.submit();
    },
    confirmLoading: updateStockLoading,
    okText: variations.find((variation) => isEditableVariation(variation)) ? isUpdateFailed ? formatMessage({id: "retry"}) : formatMessage({id: "UpdateStock"}) : formatMessage({id: "close"}),
    destroyOnClose: true,
    afterClose: () => {
      setBatchStockInputValue(void 0);
      setIsUpdateFailed(false);
      ref.current.autoFocusVariation = void 0;
    }
  }, isUpdateFailed && /* @__PURE__ */ React.createElement(Alert, {
    type: "error",
    message: formatMessage({id: "adjustSyncFailed"}),
    showIcon: true,
    style: {marginBottom: 16}
  }), /* @__PURE__ */ React.createElement(Space, {
    style: {marginBottom: 16}
  }, /* @__PURE__ */ React.createElement("span", null, formatMessage({id: "MassEditStock"}), ":"), /* @__PURE__ */ React.createElement(InputNumber, {
    value: batchStockInputValue,
    maxLength: 6,
    min: 0,
    style: {width: 160},
    onChange: (value) => setBatchStockInputValue(value)
  }), /* @__PURE__ */ React.createElement(Button, {
    type: "primary",
    onClick: () => {
      const variationStocksMap = {};
      product.details.filter((variation) => isEditableVariation(variation)).forEach((variation) => {
        variationStocksMap[variation.id] = batchStockInputValue;
      });
      form.setFieldsValue({variationStocksMap});
    }
  }, formatMessage({id: "ApplyToAll"}))), /* @__PURE__ */ React.createElement(GnForm, {
    form,
    onFinish: (values) => {
      const variationIds = Object.keys(values.variationStocksMap ?? {});
      if (variationIds.length) {
        const variationStocks = variationIds.map((variationId) => ({
          variationId,
          newStock: values.variationStocksMap[variationId]
        }));
        updateStocks(variationStocks);
      } else {
        onClose();
      }
    }
  }, /* @__PURE__ */ React.createElement(GnTable, {
    rowKey: "id",
    dataSource: variations ?? [],
    pagination: false,
    sticky: {offsetHeader: -16}
  }, /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "variantName"}),
    dataIndex: "name",
    width: "25%",
    render: (value) => value || "-"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "sku"}),
    dataIndex: "sku",
    width: "25%",
    render: (value) => value || "-"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "CurrentStock"}),
    dataIndex: "stock",
    width: "25%",
    render: (value) => value || "-"
  }), /* @__PURE__ */ React.createElement(GnTable.Column, {
    title: formatMessage({id: "NewStock"}),
    width: "25%",
    render: (variation) => isEditableVariation(variation) ? /* @__PURE__ */ React.createElement(GnForm.Item, {
      name: ["variationStocksMap", variation.id],
      initialValue: variation.stock,
      prefabKey: "InputNumber",
      className: "inline-explain",
      rules: [{required: true}],
      componentProps: {
        style: {width: 160},
        maxLength: 6,
        formatter: (value) => String(value ?? "").replace?.(/\D/g, ""),
        min: 0,
        autoFocus: ref.current.autoFocusVariation === variation.id
      }
    }) : /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(Tooltip, {
      title: formatMessage({id: "hasbinded"}, {sku: variation.sku})
    }, /* @__PURE__ */ React.createElement(InfoCircleFilled, {
      style: {color: "#ADBACC"}
    })), variation.stock, /* @__PURE__ */ React.createElement(Popconfirm, {
      overlayStyle: {width: 320},
      placement: "top",
      title: formatMessage({id: "hasbinded"}, {sku: variation.sku}),
      okText: formatMessage({id: "goToEdit"}),
      onConfirm: () => {
        if (withPermission("inventory-management-2.0")) {
          updateRoute(`stock-manage-local?isku=${variation.sku}`);
        } else {
          updateRoute("stock-manage");
        }
      }
    }, /* @__PURE__ */ React.createElement(EditOutlined, null)))
  }))));
}
